import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { Container, Form } from './styles';
import { Input } from '../../components/Input';
import { Button } from '../../components/Button';
import AlertBox from '../../components/AlertBox';
import useMutationWorkspaces from '../../hooks/useMutationWorkspaces';

export default function NewWorkspacePage() {
  const [name, setName] = useState('');
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    isSuccess: true,
    content: '',
  });

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const mutation = useMutationWorkspaces({
    onError: (error) => {
      if (error.response) {
        setAlertConfig({
          show: true,
          isSuccess: false,
          content: String(error.response.data.error),
        });
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries('workspaces');

      setAlertConfig({
        show: true,
        isSuccess: true,
        content: 'Workspace criado com sucesso!',
      });

      setTimeout(() => {
        navigate('/home');
      }, 5000);
    },
  });

  function handleRegisterClick(event) {
    event.preventDefault();
    mutation.mutate({ name });
  }

  return (
    <Container>
      {alertConfig.show
        ? <AlertBox content={alertConfig.content} isSuccess={alertConfig.isSuccess} />
        : undefined}
      <h1>Novo Workspace</h1>
      <Form onSubmit={(event) => handleRegisterClick(event)}>
        <Input placeholder="Nome" value={name} onChange={(event) => setName(event.target.value)} />
        <Button type="submit">Registrar Workspace</Button>
      </Form>
    </Container>
  );
}
